export default __webpack_public_path__ + "static/media/careernavBanner02.a378d206.jpg";